import { FleekError } from './FleekError';

type PathIsNotAFileErrorOptions = {
  path: string;
};

export class PathIsNotAFileError extends FleekError<PathIsNotAFileErrorOptions> {
  public name = 'PathIsNotAFileError';

  toString = () => {
    return `Given path ${this.data.path} is not a file.`;
  };
}
